import React from "react";
import search from '../../images/Search.svg';

export function NoImage({ styles }) {
    return (
        <div className={styles.semJob}>
            <div className={styles.searchContainer}>
                <img src={search} width={60} />
            </div>
            <p>Ops! Não encontramos suas imagens.</p>
        </div>
    );
}